export default "<p>equipe works!</p>\n"